import React from "react";
import Slider from "../Slider/slider";
import Videoo from "./video";





function Homepage (){


return(
    <div>
            <Videoo/>
            <Slider/>
    </div>
)
}
export default Homepage;